import { TeachingInstitutionState } from './types';

export const TEACHING_INSTITUTION_INITIAL_STATE: TeachingInstitutionState = {
  error: false,
  teachingInstitutions: []
};
